export const SEARCH_FOR_EVENT = 'SEARCH_FOR_EVENT';
export const CLEAR_STATE = 'CLEAR_STATE';

